/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../$$_gendir/node_modules/ng-block-ui/dist/lib/components/block-ui/block-ui.component.ngfactory';
import * as i3 from 'ng-block-ui/dist/lib/components/block-ui/block-ui.component';
import * as i4 from './clmtlk/core/header/header.component.ngfactory';
import * as i5 from '../../app/clmtlk/core/header/header.component';
import * as i6 from '../../app/clmtlk/shared/service/clmtlk-session.service';
import * as i7 from '../../app/clmtlk/shared/service/clmtlk.service';
import * as i8 from '@angular/router';
import * as i9 from './clmtlk/core/footer/footer.component.ngfactory';
import * as i10 from '../../app/clmtlk/core/footer/footer.component';
import * as i11 from '../../app/app.component';
import * as i12 from '../../app/common/service/window-ref.service';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(1,0,
      (null as any),(null as any),11,'block-ui',[['name','main']],(null as any),(null as any),
      (null as any),i2.View_BlockUIComponent_0,i2.RenderType_BlockUIComponent)),i1.ɵdid(2,
      114688,(null as any),0,i3.BlockUIComponent,([] as any[]),{name:[0,'name'],message:[1,
          'message'],delayStop:[2,'delayStop']},(null as any)),(_l()(),i1.ɵted(-1,
      0,['\n  '])),(_l()(),i1.ɵeld(4,0,(null as any),0,1,'clmtlk-header',([] as any[]),
      (null as any),(null as any),(null as any),i4.View_HeaderComponent_0,i4.RenderType_HeaderComponent)),
      i1.ɵdid(5,114688,(null as any),0,i5.HeaderComponent,[i6.ClmtlkSessionService,
          i1.ChangeDetectorRef,i7.ClmtlkService],(null as any),(null as any)),(_l()(),
          i1.ɵted(-1,0,['\n    '])),(_l()(),i1.ɵeld(7,16777216,(null as any),0,1,'router-outlet',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(8,212992,(null as any),0,i8.RouterOutlet,[i8.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['\n  '])),(_l()(),i1.ɵeld(10,
          0,(null as any),0,1,'clmtlk-footer',([] as any[]),(null as any),(null as any),
          (null as any),i9.View_FooterComponent_0,i9.RenderType_FooterComponent)),
      i1.ɵdid(11,114688,(null as any),0,i10.FooterComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted(-1,0,['\n'])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n']))],(_ck,_v) => {
    const currVal_0:any = 'main';
    const currVal_1:any = 'Loading...';
    const currVal_2:any = 500;
    _ck(_v,2,0,currVal_0,currVal_1,currVal_2);
    _ck(_v,5,0);
    _ck(_v,8,0);
    _ck(_v,11,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'clmtlk-root',
      ([] as any[]),(null as any),(null as any),(null as any),View_AppComponent_0,
      RenderType_AppComponent)),i1.ɵdid(1,114688,(null as any),0,i11.AppComponent,
      [i12.WindowRefService,i8.Router],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i11.AppComponent> = i1.ɵccf('clmtlk-root',
    i11.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvamVua2luc19ob21lL3dvcmtzcGFjZS9DTEFJTVNfUElQRUxJTkUvQ0xNVExLX1VJX0FQUF9QSVBFTElORS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy92YXIvamVua2luc19ob21lL3dvcmtzcGFjZS9DTEFJTVNfUElQRUxJTkUvQ0xNVExLX1VJX0FQUF9QSVBFTElORS9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbjxibG9jay11aSBuYW1lPSdtYWluJyBbbWVzc2FnZV09XCInTG9hZGluZy4uLidcIiBbZGVsYXlTdG9wXT1cIjUwMFwiPlxuICA8Y2xtdGxrLWhlYWRlcj48L2NsbXRsay1oZWFkZXI+XG4gICAgPHJvdXRlci1vdXRsZXQgPjwvcm91dGVyLW91dGxldD5cbiAgPGNsbXRsay1mb290ZXI+PC9jbG10bGstZm9vdGVyPlxuPC9ibG9jay11aT5cbiIsIjxjbG10bGstcm9vdD48L2NsbXRsay1yb290PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsMENBQ0E7TUFBQTtNQUFBLGlGQUFBO01BQUE7VUFBQSxxREFBaUU7TUFBQSxhQUMvRDtNQUFBO2FBQUE7K0NBQUEsK0JBQStCO2lCQUFBLG1CQUM3QjtVQUFBO2FBQUE7MERBQUE7VUFBQSw2QkFBZ0MsZ0NBQ2xDO1VBQUE7VUFBQTthQUFBO1VBQUEsZUFBK0IsOEJBQ3RCO1VBQUE7SUFKRDtJQUFZO0lBQXlCO0lBQS9DLFdBQVUsVUFBWSxVQUF5QixTQUEvQztJQUNFO0lBQ0U7SUFDRjs7OztvQkNKRjtNQUFBOzZCQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/app/app.component.ngfactory.ts